import React from 'react'
import CopyLinkSVG from 'images/copy-link.svg'
import copy from 'copy-to-clipboard'

import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import TextField from '@mui/material/TextField'
import './CopyLinkModal.scss'

export const CopyLinkModal = ({ open, handleClose, shareUrl }) => {
  const theUrl = shareUrl
    ? shareUrl
    : typeof window !== 'undefined' && window.location.href

  // Copies from the Dialog's `onEntered` transition callback rather than a
  // useEffect keyed on `open`: the parent keeps this component mounted with
  // open=false so the Dialog can animate open, and a plain effect fired
  // before MUI finished mounting the transitioned-in content, so the
  // querySelector below found nothing and `copy` silently never ran (no
  // error - it just bailed via the `!urlInput` check). `onEntered` only
  // fires once the enter transition has completed and the input is
  // actually in the DOM.
  const handleEntered = () => {
    if (typeof window === 'undefined') return
    const urlInput = document.querySelector(
      '.modal-copy-link .input-container input',
    )
    if (!urlInput) return
    urlInput.select()
    copy(urlInput.value)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="copy-link-dialog-title"
      maxWidth={false}
      TransitionProps={{ onEntered: handleEntered }}
    >
      {/* overflowX: 'hidden' - MUI's DialogContent defaults to overflowY:
      'auto', and per the CSS overflow computation rules that makes overflowX
      compute to 'auto' too (the deleted Modal.scss's own .modal-container had
      the identical guard, with a comment explaining the same quirk). The
      close button's rotated ::before/::after pseudo-elements bleed a couple
      px past their box, which is enough to spawn a phantom horizontal
      scrollbar without this. */}
      <DialogContent sx={{ padding: 0, overflowX: 'hidden' }}>
        <div className={`modal-forgot modal-copy-link new-form-fields `}>
          <button
            className="modal-close gray-close-button"
            onClick={handleClose}
            aria-label="Next"
          ></button>
          <img className="header-image" src={CopyLinkSVG} alt="" />
          <h1 id="copy-link-dialog-title">Link Copied </h1>
          <p>Shareable link has been copied to your clipboard.</p>
          <div className="input-container">
            <TextField id="outlined-basic" variant="outlined" value={theUrl} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
